export default "__VITE_ASSET__45fc5ec1__"